import Vue from 'vue'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

Vue.use(DatePicker) // or with global options Vue.use(VuePromiseBtn, {})
